import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class BattleGiveUpConfirmationPanel extends VerticalStandardPanel {

    private onAcceptCallback!: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, onAcceptCallback: () => unknown, clickSound: Phaser.Sound.BaseSound | undefined) {
        super(scene, canvas, Tr('kapituljatsija'));

        this.onAcceptCallback = onAcceptCallback;

        let title = TextUtils.addTextByFamily(scene, Tr('vi.uvereni.chto.hotite.sdatsja'), 0, -20,
            '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

        let flag = SpriteUtils.addImage(this.scene, title.x, -200, Keys.ATLAS_UI, Keys.IMG_GIVE_UP_FLAG, 0.5)
            .setOrigin(0.5, 0);

        let declineButton = new SquareButton(scene, -100, 135, 0, Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, Tr('otmena'), false);

        let acceptButton = new SquareButton(scene, 100, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('sdatsja'), false, 80 * CU.S, 80 * CU.S);

        declineButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (this.isOnTop()) {
                this.close();
            }
        });

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (this.isOnTop()) {
                if (this.onAcceptCallback != null) { this.onAcceptCallback(); }
                this.close();
            }
        });

        this.add([title, flag, acceptButton, declineButton]);

        SpriteUtils.scale(this, 0.9 / CU.S, 0.9 / CU.S);
    }
}
